const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';

export const setQueryParams = (payload) => {
    return {
    type: SET_QUERY_PARAMS,
    payload : payload 
  }};
